import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

// Generic ApexCharts wrapper for the admin dashboard cards (donut, bars...):
//   <div data-controller="apex-chart" data-apex-chart-options-value="<%= {...}.to_json %>"></div>
// The options are plain ApexCharts options built in the view.
export default class extends Controller {
  static values = { options: Object }

  connect() {
    this.chart = new ApexCharts(this.element, this.optionsValue)
    this.chart.render()
  }

  disconnect() {
    this.chart?.destroy()
  }
}
